<template>
  <v-container class="pa-2">
    <v-snackbar
      :timeout="5000"
      :value="message.show"
      absolute
      top
      :color="message.type"
      style="z-index: 999999999"
    >
      <v-alert :type="message.type" class="mb-0"> {{ message.text }} </v-alert>
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="message.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <search-bar @onSearch="searchByName($event)" />
    <EasyRefresh id="storeList" class="mt-4"
      :userSelect="false"
      :onRefresh="onRefresh"
      :loadMore="loadMore"
      style="height: calc(100% - 95px)"
    >
    <v-card
          v-for="(item, index) in items"
          :key="item.id"
          outlined
          tile
          height="200px"
          class="disInfo"
          :style="{
            'border-left-color': colors[index % 10],
          }"
        >
          <v-card-text style="height: 100%" class="pa-0 px-2">
            <v-row class="ma-0" style="height: 100%">
              <v-col cols="11" class="pa-0">
                <v-list class="transparent">
                  <v-list-item class="px-0">
                    <v-list-item-title> 开发时间 </v-list-item-title>

                    <v-list-item-subtitle class="text-right">
                      {{ item.addDate }}
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="px-0">
                    <v-list-item-title> 经销商名称 </v-list-item-title>

                    <v-list-item-subtitle class="text-right">
                      {{ item?.dealer?.name }}
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="px-0">
                    <v-list-item-title> 门店名称 </v-list-item-title>

                    <v-list-item-subtitle class="text-right">
                      {{ item.name }}
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="px-0">
                    <v-list-item-title> 电话 </v-list-item-title>

                    <v-list-item-subtitle class="text-right">
                      {{ item.tel }}
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="px-0">
                    <v-list-item-title> 门店类型 </v-list-item-title>

                    <v-list-item-subtitle class="text-right">
                      {{ item?.category?.name }}
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="px-0">
                    <v-list-item-title> 预计当年博世壁挂炉采购贡献(台) </v-list-item-title>

                    <v-list-item-subtitle class="text-right">
                      {{ item.yearlySalesCapacity }}
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="px-0">
                    <v-list-item-title> 出样产品 </v-list-item-title>

                    <v-list-item-subtitle class="text-right">
                      {{ item.samples }}
                    </v-list-item-subtitle>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col cols="1" class="pa-0 toDetail">
                <v-btn icon link :to="`/store/detail/${item.id}`">
                  <v-icon large>mdi-chevron-right</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
    </EasyRefresh>

    <v-row class="ma-0 pt-2">
      <v-spacer></v-spacer>

      <v-btn
        outlined
        tile
        v-if="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')"
        class="success white--text ml-2"
        @click="redirectToAdd"
        >新增
      </v-btn>
      <v-btn
        outlined
        tile
        class="primary white--text mr-2"
        v-if="user.role?.includes('RRS')"
        @click="dialog = true"
        >导入</v-btn
      >
      <v-btn
        outlined
        tile
        v-if="!user.role?.includes('Sales')"
        class="primary white--text"
        @click="exportStore"
        >导出</v-btn
      >
    </v-row>
    <v-dialog v-model="dialog" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">导入</span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-form class="px-4 pt-2" ref="form" lazy-validation>
            <v-file-input
              truncate-length="15"
              v-model="fileToImport"
            ></v-file-input>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialog = false">
            关闭
          </v-btn>
          <v-btn color="blue darken-1" text @click="save"> 保存 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="loading" style="z-index: 99999999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import SearchBar from "../../components/SearchBar.vue";
import api from "../../api/api";
export default {
  name: "StoreForSales",
  components: {
    SearchBar,
  },
  data: () => ({
    message: {
      show: false,
      type: "success",
      text: "",
    },
    loading: false,
    items: [],
    pageIndex: 0,
    pageSize: 10,
    colors: [
      "#D42027",
      "#8E2E62",
      "#893680",
      "#573B8E",
      "#2C3D7D",
      "#322C6F",
      "#089AD3",
      "#04b2d9",
      "#599956",
      "#87b957",
    ],
    payload: {
      region: null,
      province: null,
      city: null,
      salesId: null,
      year: null,
      name: null,
      developmentStatus: null,
      categoryIdList: null,
    },
    dialog: false,
    fileToImport: null,
  }),
  computed: {
    ...mapState(["category", "user"]),
  },
  created() {
    this.payload.region = this.$route.query.region || "";
    this.payload.province = this.$route.query.province || "";
    this.payload.city = this.$route.query.city || "";
    this.payload.salesId = this.$route.query.salesId || "";
    this.payload.year = this.$route.query.year || "";
    this.payload.developmentStatus = this.$route.query.developmentStatus || "";
    this.payload.categoryIdList = this.$route.query.categoryIdList || "";
    this.getStoreData("");
  },
  methods: {
    onRefresh: function (done) {
      var self = this;
      self.pageIndex = self.pageIndex - self.pageSize;
      if (self.pageIndex < 0) {
        self.pageIndex = self.pageIndex + self.pageSize;
        done();
        this.message = {
          show: true,
          type: "info",
          text: "没有更多数据！",
        };
      } else {
        if (self.payload.name) {
          self.getStoreData(self.payload.name);
        } else {
          self.getStoreData("");
        }
        done();
      }
    },
    loadMore: function (done) {
      var self = this;
      self.pageIndex = self.pageIndex + self.pageSize;
      if (self.payload.name) {
        self.getStoreData(self.payload.name);
      } else {
        self.getStoreData("");
      }
      done();
    },
    searchByName($event) {
      this.payload.name = $event;
      this.getStoreData($event);
    },
    async getStoreData(name) {
      this.loading = true;
      let userId = "";
      if (this.user.role?.includes('Sales')) {
        userId = this.user.userId;
      }
      api.store
        .getStoreList(
          `/store?name=${name}&region=${
            this.$route.query.region || ""
          }&province=${this.$route.query.province || ""}&city=${
            this.$route.query.city || ""
          }&salesId=${this.$route.query.salesId || userId}&year=${
            this.$route.query.year || ""
          }&pageIndex=${this.pageIndex}&pageSize=${
            this.pageSize
          }&developmentStatus=${this.$route.query.developmentStatus || ""
          }&categoryIdList=${
            this.$route.query.categoryIdList || ""
          }`
        )
        .then((res) => {
          const { data, status } = res?.data || {};
          if (status == 200 && data) {
            this.items = data.list.map((item) => {
              let samples = "";
              const sampleIds = item.sampleIds?.split(",");
              if (sampleIds?.length) {
                samples = sampleIds
                  .map((i) => {
                    const sampleId = this.category.filter(
                      (c) => c.id == i && c.categoryType == "zxjx"
                    );
                    if (sampleId.length) {
                      return sampleId[0].name;
                    } else {
                      return null;
                    }
                  })
                  .filter((i) => !!i)
                  .join(",");
              }
              return {
                ...item,
                addDate: item?.addDate?.slice(0, 7),
                samples,
              };
            });
          } else if (status == 200 && !data) {
            if (this.pageIndex > 0) {
              this.pageIndex = this.pageIndex - this.pageSize;
            }
            this.message = {
              show: true,
              type: "info",
              text: "没有更多数据！",
            };
          } else {
            this.items = [];
            this.message = {
              show: true,
              type: "info",
              text: "没有数据！",
            };
          }
        })
        .finally(() => {
          this.loading = false;
          setTimeout(() => {
            this.message.show = false;
          }, 600000);
        });
    },
    redirectToAdd() {
      this.$router.push({
        path: "/store/detail/0",
      });
    },
    exportStore() {
      this.loading = true;
      this.payload.name = this.payload.name || "";
      api.store
        .exportStore(this.payload)
        .then((res) => {
          if (
            res.data.type ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ) {
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(res.data);
            link.download = "门店清单";
            link.click();
          } else {
            alert("导出失败，请重试！");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    save() {
      if (!this.fileToImport) {
        this.message = {
          show: true,
          type: "info",
          text: "请上传文档！",
        };
        setTimeout(() => {
          this.message.show = false;
        }, 600000);
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append("file", this.fileToImport, this.fileToImport.name);
      api.store
        .importStore(formData)
        .then((res) => {
          if (
            res.data.type ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ) {
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(res.data);
            link.download = `导入结果`;
            link.click();
            this.fileToImport = null;
            this.dialog = false;
          } else {
            alert("导入失败，请重试！");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="sass">
#storeList
  height: calc(var(--vh, 1vh) * 100 - 48px)
  .toDetail
    display: grid
    place-self: center
  .disInfo
    border-left-width: 5px
    border-left-style: solid
    .v-list-item
      min-height: 25px
      .v-list-item__title
        overflow: visible
</style>
